/*
 * Public API Surface of ng-jalali-date-time
 */

export { NgJalaliDateTimeModule } from './lib/ng-jalali-date-time.module';

export { NgJalaliDateTimeValueInterface } from './lib/component/ng-jalali-date-time/ng-jalali-date-time.interface';
export { NgJalaliMonthValueInterface } from './lib/component/ng-jalali-month/ng-jalali-month.interface';
export { NgJalaliRangeValueInterface } from './lib/component/ng-jalali-range/ng-jalali-range.interface';

export { NgJalaliDateTimeConfigInterface, NgJalaliDateTimeCssInterface } from './lib/ng-jalali-date-time.interface';
